import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const ArrowDownwardIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="arrow-down" {...props} />;
};

export { ArrowDownwardIcon };
